import { render, staticRenderFns } from "./devpointdetail.vue?vue&type=template&id=1746252e&scoped=true"
import script from "./devpointdetail.vue?vue&type=script&lang=js"
export * from "./devpointdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746252e",
  null
  
)

export default component.exports